export class UploadFile {
    fileName: string;
    fileSize: number;
    file: File;
}
